import { RootState } from "../../Store";

// Selectors
export const selectIsPlaceOrderInProgress = (state: RootState) => state.orders.isPlaceOrderInProgress;

export const selectIsPlaceOrderSuccess = (state: RootState) => state.orders.isPlaceOrderSuccess;

export const selectIsPlaceOrderFailed = (state: RootState) => state.orders.isPlaceOrderFailed;

export const selectIsPlaceOrderComplete = (state: RootState) => state.orders.isPlaceOrderComplete;

export const selectTotalOrderProcessed = (state: RootState) => state.orders.totalOrderProcessed;

export const selectSuccessOrdersData = (state: RootState) => state.orders.successData;

export const selectErrorOrdersData = (state: RootState) => state.orders.errorsData;

export const selectOrderLeads = (state: RootState) => state.orders.orderLeads;